/**
 * Parser de markdown ligero para las respuestas del agente.
 *
 * Cubre lo esencial (bold, italic, código inline, listas, links, saltos de
 * línea) sin añadir dependencias nuevas. Escapa HTML primero para evitar XSS.
 */

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function renderMarkdown(input: string): string {
  let s = escapeHtml(input);

  // Bloques de código triple-backtick
  s = s.replace(/```([\s\S]*?)```/g, (_m, code) => `<pre><code>${code}</code></pre>`);

  // Código inline
  s = s.replace(/`([^`\n]+)`/g, "<code>$1</code>");

  // Bold + italic
  s = s.replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>");
  s = s.replace(/(^|\W)\*([^*\n]+)\*/g, "$1<em>$2</em>");

  // Links [texto](url)
  s = s.replace(
    /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
  );

  // Listas: convierte bloques consecutivos de "- ..." en <ul><li>...</li></ul>
  s = s.replace(
    /(?:^|\n)((?:- [^\n]+\n?)+)/g,
    (_m, block: string) => {
      const items = block
        .trim()
        .split(/\n/)
        .map((line) => line.replace(/^- /, "").trim())
        .filter(Boolean)
        .map((it) => `<li>${it}</li>`)
        .join("");
      return `\n<ul>${items}</ul>`;
    },
  );

  // Saltos de línea simples → <br>
  s = s.replace(/\n/g, "<br />");

  return s;
}
